import React  from "react";
import { useEffect } from "react";
import { useState } from "react";

import Project  from "./project";

import Projectservice from "../../service/Projectservice";

import "./styles/allProjects.css";


const AllProjects = () => {
	const [data, setData] = useState([]);
	
	useEffect(() => {
	  getData();
	}, []);
  
	const getData = async () => {
	  try {
		const response = await Projectservice.getAllInfo();
      const newData = response.docs.map((doc) => doc.data()); // Extract data from each document
      setData(newData);
	  } catch (error) {
		console.error("Error fetching data:", error);
	  }
	};
	return (
		<div className="all-projects-container">
			{data.map((project, index) => (
				<div className="all-projects-project" key={index}>
					<Project
						logo={project.logo}
						title={project.title}
						description={project.description}
						linkText={project.linkText}
						link={project.link}
					/>
				</div>
			))}
		</div>
	);
};

export default AllProjects;
